"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const color_1 = __importDefault(require("color"));
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const constants_1 = require("../../../utilities/constants");
const constants_2 = require("../constants");
const FittedLabel_1 = __importDefault(require("../FittedLabel"));
const model_1 = require("../model");
require("./styles.css");
const Mosaic = _ref => {
  let {
    height,
    width,
    groups,
    categories,
    selectedCategories,
    metricsByGroupByCategory,
    proportionsBySubgroup,
    setSelected,
    unitSpan,
    targetRef,
    fontSize = 14,
    labelWidth = 0
  } = _ref;
  const proportionsByGroup = lodash_1.default.mapValues(proportionsBySubgroup, categories => (0, lodash_1.default)(categories).flatMap(subcategories => lodash_1.default.map(subcategories, v => v)).sum());
  const [hovered, setHovered] = (0, react_1.useState)(null);
  const labelSectionWidth = labelWidth || constants_2.LABEL_SECTION_WIDTH;
  const availableHeight = height - (groups.length - 1) * constants_2.RECT_PADDING_Y;
  const availableWidth = width - labelSectionWidth - (categories.length - 1) * constants_2.RECT_PADDING_X;
  const categoriesLayout = (0, model_1.getRowLabelsLayout)(groups, proportionsByGroup, availableHeight, constants_2.RECT_PADDING_Y, fontSize);
  const rectLayout = (0, model_1.getRectLayout)(groups, categories, availableHeight, availableWidth, selectedCategories, metricsByGroupByCategory, proportionsBySubgroup, labelSectionWidth);
  const firstNonZeroCategoryIndex = categoriesLayout.findIndex(_ref2 => {
    let {
      height
    } = _ref2;
    return height;
  });
  const labels = categoriesLayout.map((_ref3, i) => {
    let {
      height,
      group,
      y
    } = _ref3;
    return categoriesLayout[i].height > 0 && react_1.default.createElement("div", {
      className: "label",
      // eslint-disable-next-line react/no-array-index-key
      key: i,
      style: {
        height,
        top: y,
        position: 'absolute',
        width: `${labelSectionWidth}px`,
        fontSize: `${fontSize}px`
      }
    }, react_1.default.createElement("span", {
      className: "group-label"
    }, categoriesLayout[i].label), categoriesLayout[i].height > fontSize * 2 && react_1.default.createElement("span", {
      className: "group-value"
    }, `${Math.round(proportionsByGroup[group] * 100)}%`), i === firstNonZeroCategoryIndex ? react_1.default.createElement("span", {
      className: "group-units"
    }, unitSpan) : null);
  });
  const labelSpans = rectLayout.map((_ref4, i) => {
    let {
      width,
      height,
      label
    } = _ref4;
    return react_1.default.createElement(FittedLabel_1.default
    // eslint-disable-next-line react/no-array-index-key
    , {
      // eslint-disable-next-line react/no-array-index-key
      key: i,
      text: label,
      width: width - 2 * constants_2.LABEL_PADDING_X,
      height: height - 2 * constants_2.LABEL_PADDING_Y,
      fontSize: fontSize,
      fontFamily: constants_1.FONT_FAMILY
    });
  });
  const animatedLabelContainers = rectLayout.map((_ref5, i) => {
    let {
      x,
      y,
      width,
      height,
      opacity
    } = _ref5;
    const {
      group,
      category,
      metric,
      color
    } = rectLayout[i] || {};
    const isHovered = hovered && hovered.category === category && hovered.group === group && hovered.metric === metric;
    const strokeWidth = isHovered ? Math.min(4, rectLayout[i].width / 2) : 0;
    return (
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      react_1.default.createElement("div", {
        // eslint-disable-next-line react/no-array-index-key
        key: i,
        className: "rect",
        style: {
          position: 'absolute',
          top: y,
          left: x,
          height,
          width,
          boxSizing: 'border-box',
          border: `${(0, color_1.default)(color).mix((0, color_1.default)('white'), 0.5).string()} solid ${strokeWidth}px`,
          background: color,
          opacity,
          paddingTop: `${Math.max(0, Math.min(constants_2.LABEL_PADDING_Y, height / 2) - strokeWidth)}px`,
          paddingLeft: `${Math.max(0, Math.min(constants_2.LABEL_PADDING_X, width / 2) - strokeWidth)}px`
        },
        onMouseOver: () => {
          setHovered({
            group,
            category,
            metric
          });
          setSelected({
            group,
            category,
            metric
          });
        }
      }, labelSpans[i])
    );
  });
  if (!height || !width) {
    return react_1.default.createElement("div", {
      className: "mosaic",
      ref: targetRef
    });
  }
  return react_1.default.createElement("div", {
    className: "mosaic",
    ref: targetRef,
    onMouseLeave: () => {
      setHovered(null);
      setSelected(null);
    }
  }, react_1.default.createElement("div", {
    className: "labels-container"
  }, labels), react_1.default.createElement("div", {
    className: "rects-container"
  }, animatedLabelContainers));
};
Mosaic.propTypes = {
  width: prop_types_1.number,
  height: prop_types_1.number,
  /**
   * IDs and labels of groups
   */
  groups: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired
  })).isRequired,
  /**
   * IDs, labels and colors of categories
   */
  categories: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired,
    color: prop_types_1.string
  })),
  selectedCategories: (0, prop_types_1.arrayOf)(prop_types_1.string).isRequired,
  metricsByGroupByCategory: (0, prop_types_1.shape)().isRequired,
  proportionsBySubgroup: (0, prop_types_1.shape)().isRequired,
  setSelected: prop_types_1.func.isRequired,
  unitSpan: (0, prop_types_1.shape)().isRequired,
  targetRef: (0, prop_types_1.shape)({
    current: (0, prop_types_1.shape)()
  }),
  fontSize: prop_types_1.number,
  labelWidth: prop_types_1.number
};
exports.default = Mosaic;